import { createAction } from '@reduxjs/toolkit';
export const getLibraryList = createAction('library/getLibraryList');
export const getLibraryListResolved = createAction('library/getLibraryList/resolved');
export const getLibraryListRejected = createAction('library/getLibraryList/rejected');
